import { DashboardLayout } from '@/components/layout/dashboard'
import { sanitizeRedirect } from '@sul/shared/utils'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/')({
  validateSearch: (
    search?: Record<string, unknown>,
  ): { redirect?: string; error?: string } => ({
    redirect: sanitizeRedirect(search?.redirect),
    error: (search?.error as string | undefined) ?? undefined,
  }),
  component: HomeComponent,
  head: () => ({
    meta: [
      { name: 'SUL AI', content: 'SUL AI' },
      { title: 'SUL AI | Dashboard' },
    ],
  }),
})

export function HomeComponent() {
  return <DashboardLayout />
}
